import * as React from 'react'
import { useTheme } from 'styled-components'

interface Props {
  /** The <input /> element. */
  children: JSX.Element
  style?: React.CSSProperties
  className?: string

  prefix?: JSX.Element | string
  prefixStyle?: React.CSSProperties
  prefixClassName?: string

  suffix?: JSX.Element | string
  suffixStyle?: React.CSSProperties
  suffixClassName?: string
}

export default function InputPrefixSuffixComponent ({ children, style, className, prefix, prefixStyle, prefixClassName, suffix, suffixStyle, suffixClassName }: Props) {
  const theme = useTheme()
  const inputStyle: React.CSSProperties = {
    borderTopLeftRadius: prefix ? 0 : undefined,
    borderBottomLeftRadius: prefix ? 0 : undefined,
    borderTopRightRadius: suffix ? 0 : undefined,
    borderBottomRightRadius: suffix ? 0 : undefined,
    width: 'unset',
    flexGrow: 1
  }

  const input = React.cloneElement(children, { style: inputStyle })

  const buildAffixNode = React.useCallback((
    affix: JSX.Element | string | undefined,
    affixDefaultStyle:  React.CSSProperties,
    propsStyle: React.CSSProperties | undefined,
    propsClassName: string | undefined
  ) => {
    if (!affix) return null

    return <div
      style={{ width: 'fit-content', overflow: 'unset',  textOverflow: 'unset', backgroundColor: theme.colors.clr_0_lightest, ...affixDefaultStyle, ...propsStyle }}
      className={ ['fakeInput', propsClassName].filter(Boolean).join(' ') }
      children={ affix } />
  }, [theme.colors.clr_0_lightest])

  const prefixNode = React.useMemo(() => {
    return buildAffixNode(prefix, { borderTopRightRadius: 0, borderBottomRightRadius: 0, borderRight: 0 }, prefixStyle, prefixClassName)
  }, [buildAffixNode, prefix, prefixStyle, prefixClassName])

  const suffixNode = React.useMemo(() => {
    return buildAffixNode(suffix, { borderTopLeftRadius: 0, borderBottomLeftRadius: 0, borderLeft: 0 }, suffixStyle, suffixClassName)
  }, [buildAffixNode, suffix, suffixStyle, suffixClassName])

  return <div style={{ display: 'flex', ...style }} className={ className }>
    { prefixNode }
    { input }
    { suffixNode }
  </div>
}
